import { openDB } from "idb";

const DB_NAME = "hscis_offline_db";
const DB_VERSION = 1;
const STORE_NAME = "offline_queue";

export async function initDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id", autoIncrement: true });
      }
    },
  });
}

/**
 * Save an offline request to IndexedDB.
 * payload: The json payload of the request.
 * file: (optional) Blob/File for evidence.
 * endpoint: API endpoint (e.g., "/prospects" or "/evidence")
 */
export async function addOfflineRequest(endpoint, payload, file = null) {
  const db = await initDB();
  await db.add(STORE_NAME, {
    endpoint,
    payload,
    file,
    timestamp: Date.now(),
  });
}

export async function getOfflineRequests() {
  const db = await initDB();
  return db.getAll(STORE_NAME);
}

export async function removeOfflineRequest(id) {
  const db = await initDB();
  return db.delete(STORE_NAME, id);
}

export async function clearOfflineRequests() {
  const db = await initDB();
  return db.clear(STORE_NAME);
}
